import { render, staticRenderFns } from "./DirectRequestDelivery.vue?vue&type=template&id=5bc3cad6&"
import script from "./DirectRequestDelivery.vue?vue&type=script&lang=js&"
export * from "./DirectRequestDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports